import { render } from "./Lightboxes.vue?vue&type=template&id=68aaf404&scoped=true"
import script from "./Lightboxes.vue?vue&type=script&lang=js"
export * from "./Lightboxes.vue?vue&type=script&lang=js"

import "./Lightboxes.vue?vue&type=style&index=0&id=68aaf404&scoped=true&lang=css"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68aaf404"]])

export default __exports__